var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.noView)?_c(_vm.story.content.component,{tag:"component",attrs:{"blok":_vm.story.content}}):_c('ViewContainer',{staticClass:"view-storyblok"},[_c(_vm.story.content.component,{tag:"component",attrs:{"blok":_vm.story.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }